import { cn } from "design/lib"
import type { SparkColour } from "../../lib"
import { SPARKS } from "../../lib"

type Props = {
  spark: SparkColour
  size?: "small" | "medium"
  className?: string
}

export default function Dot({ spark, size = "medium", className }: Props) {
  return (
    <div
      className={cn(
        "pointer-events-none rounded-full",
        SPARKS[spark].bg,
        size === "medium" ? "size-2.5" : "size-2",
        className,
      )}
    />
  )
}
